import { IWorkTimeResponse, IOverrideDay, EDay as EWidgetDay } from '@cian/callback-widget';

import { EDay } from '../repositories/work-time/entities/day_of_week_schedule/DayOfWeekScheduleSchema';
import { IGetScheduleByUserResponse } from '../repositories/work-time/v1/get-schedule-by-user';

const DAYS_MAP = new Map<EDay, EWidgetDay>([
  [EDay.Monday, EWidgetDay.Monday],
  [EDay.Tuesday, EWidgetDay.Tuesday],
  [EDay.Wednesday, EWidgetDay.Wednesday],
  [EDay.Thursday, EWidgetDay.Thursday],
  [EDay.Friday, EWidgetDay.Friday],
  [EDay.Saturday, EWidgetDay.Saturday],
  [EDay.Sunday, EWidgetDay.Sunday],
]);

export const transformWorkTimeSchedule = (data: IGetScheduleByUserResponse): IWorkTimeResponse => {
  const { callFrom, callTo } = data;

  const overridesByDays = (data.overridesByDays || []).reduce<IOverrideDay[]>((acc, item) => {
    const overrideDay = item.day && DAYS_MAP.get(item.day);

    if (overrideDay && typeof item.isWorkingDay === 'boolean') {
      acc.push({
        callFrom: item.callFrom,
        callTo: item.callTo,
        day: overrideDay,
        isWorkingDay: item.isWorkingDay,
      });
    }

    return acc;
  }, []);

  return {
    callFrom: callFrom as string,
    callTo: callTo as string,
    overridesByDays,
  };
};
